<template>
    <div>
        <div class="sau-bx-shadow p-6">
            <sau-invoice-payment></sau-invoice-payment>
        </div>
    </div>
</template>

<script>
import InvoicePayment from './_PaymentInvoiceRHS';
// import CreditPayment from './_PaymentCreditRHS';
export default {
    components:{
		'sau-invoice-payment': InvoicePayment,
    },

}
</script>
